import { render, staticRenderFns } from "./PuntoVentaTransporte.vue?vue&type=template&id=db214b8c&scoped=true&"
import script from "./PuntoVentaTransporte.vue?vue&type=script&lang=js&"
export * from "./PuntoVentaTransporte.vue?vue&type=script&lang=js&"
import style0 from "./PuntoVentaTransporte.vue?vue&type=style&index=0&id=db214b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db214b8c",
  null
  
)

export default component.exports